import React from 'react';
import { pricingPackages } from '../data';
import { Check, Info } from 'lucide-react';
import { motion } from 'framer-motion';

export default function Packages() {
  return (
    <section id="pakker" className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <h2 className="text-slate-500 font-bold tracking-widest uppercase text-sm mb-4">Vores Pakkeløsninger</h2>
          <h3 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight uppercase">
            Priser tilpasset din bils størrelse
          </h3>
          <p className="text-lg text-slate-600">
            Alle priser er vejledende og inkl. moms. Den endelige pris afhænger af bilens stand.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPackages.map((pkg, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className={`relative flex flex-col p-8 rounded-3xl bg-white border ${pkg.popular ? 'border-blue-900 shadow-xl shadow-blue-900/5' : 'border-slate-100'} transition-all`}
            >
              {pkg.popular && (
                <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-blue-900 text-white text-xs font-black uppercase tracking-widest px-4 py-1.5 rounded-full">
                  Mest Populær
                </div>
              )}
              
              <div className="mb-8">
                <h4 className="text-2xl font-black text-slate-900 mb-1 uppercase">{pkg.name}</h4>
                <p className="text-slate-500 text-sm font-medium">{pkg.size}</p>
              </div>

              <div className="flex items-baseline gap-1 mb-8">
                <span className="text-slate-500 text-sm font-bold">Fra</span>
                <span className="text-4xl font-black text-slate-900">{pkg.price}</span>
                <span className="text-slate-500 text-sm font-bold">kr.</span>
              </div>

              <div className="flex-1 space-y-4 mb-8">
                <div className="flex items-start gap-2 p-3 bg-slate-50 rounded-2xl mb-4">
                  <Info size={16} className="text-slate-400 shrink-0 mt-0.5" />
                  <p className="text-[11px] text-slate-500 leading-tight">
                    F.eks: {pkg.examples}
                  </p>
                </div>
                
                {pkg.features.map((feature, fIndex) => (
                  <div key={fIndex} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full bg-sky-50 flex items-center justify-center text-blue-900 shrink-0 mt-0.5">
                      <Check size={12} strokeWidth={3} />
                    </div>
                    <span className="text-sm text-slate-600 font-medium leading-snug">{feature}</span>
                  </div>
                ))}
              </div>

              <a 
                href="#kontakt"
                className={`w-full py-4 rounded-full font-bold text-center transition-all active:scale-95 ${
                  pkg.popular 
                    ? 'bg-blue-900 text-white hover:bg-blue-800 shadow-lg shadow-blue-900/10' 
                    : 'bg-slate-100 text-slate-900 hover:bg-slate-200'
                }`}
              >
                Bestil Tid
              </a>
            </motion.div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm flex items-center justify-center gap-2">
            <Info size={16} /> Alle priser er inkl. 3 års certificeret keramisk coating.
          </p>
        </div>
      </div>
    </section>
  );
}
